import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage,transformResponse } from "../baseQuery";

export const HomeMenuApiSlice = createApi({
  reducerPath: "HomemenuApiSlice",
  baseQuery,

  tagTypes: ["menu"],

  endpoints: (builder) => ({
    // Menu API
    getMenuApi: builder.query({
      query: () => ({
        url: "homeMenu/user",
        method: "GET",
      }),
      transformResponse,
      transformErrorResponse: transformErrorResponseWithMessage,
      providesTags: ["menu"]
    }),
  }),
});

export const {
  useGetMenuApiQuery,
} = HomeMenuApiSlice; 